import { createSignal } from "solid-js";

export type Theme = "light" | "dark";

const STORAGE_KEY = "snippland-theme";

// Browser chrome (status bar / address bar / mobile bottom area) colors.
// Must match --color-bg in index.css for both themes so the device UI does
// not stay white in dark mode (and vice-versa) on mobile.
const CHROME_COLOR: Record<Theme, string> = {
  light: "#ffffff",
  dark: "#0f1115",
};

function setThemeColorMeta(t: Theme) {
  // Remove the static media-query <meta theme-color> tags (they follow the OS
  // scheme, not our manual toggle) and set a single dynamic one.
  const head = document.head;
  head
    .querySelectorAll('meta[name="theme-color"]')
    .forEach((el) => el.remove());
  const meta = document.createElement("meta");
  meta.name = "theme-color";
  meta.content = CHROME_COLOR[t];
  head.appendChild(meta);
}

function applyTheme(t: Theme) {
  document.documentElement.classList.toggle("dark", t === "dark");
  setThemeColorMeta(t);
  try {
    localStorage.setItem(STORAGE_KEY, t);
  } catch {
    /* localStorage erisilemezse sessizce gec */
  }
}

function initialTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    /* yok say */
  }
  // Varsayilan: light mode
  return "light";
}

const [theme, setTheme] = createSignal<Theme>(initialTheme());

// Modul yuklendiginde mevcut temayi DOM'a uygula.
applyTheme(theme());

export function toggleTheme() {
  const next: Theme = theme() === "dark" ? "light" : "dark";
  setTheme(next);
  applyTheme(next);
}

export { theme };
